"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAppendedOrderKey = void 0;
const fractional_indexing_1 = require("fractional-indexing");
const lodash_1 = require("lodash");
const models_1 = require("./models");
const START_KEY = null;
const END_KEY = null;
function generateAppendedOrderKey(existingKeys) {
    const sorted = (0, lodash_1.compact)([...existingKeys]).sort();
    const [last] = sorted.slice(-1);
    return generateOrderKeyAfter(sorted, last);
}
exports.generateAppendedOrderKey = generateAppendedOrderKey;
function generateOrderKeyAfter(existingKeys, afterKey) {
    const [lowerBoundary, upperBoundary] = boundsParams(existingKeys, afterKey);
    return (0, fractional_indexing_1.generateKeyBetween)(lowerBoundary, upperBoundary);
}
function boundsParams(existingKeys, afterKey) {
    const noExistingKeys = existingKeys.length === 0;
    if (noExistingKeys) {
        return [START_KEY, END_KEY];
    }
    const sortedExistingKeys = [...existingKeys].sort();
    if (afterKey === START_KEY) {
        const [first] = sortedExistingKeys;
        return [START_KEY, first];
    }
    const [last] = sortedExistingKeys.slice(-1);
    const lowerBoundary = afterKey || last;
    const lowerBoundaryIndex = sortedExistingKeys.findIndex((order) => order === afterKey);
    const lowerBoundaryNotFound = lowerBoundaryIndex === -1;
    if (lowerBoundaryNotFound) {
        throw new models_1.NotFoundError(`fractional index could not be found`, { afterKey });
    }
    const upperBoundary = lowerBoundary === last ? END_KEY : sortedExistingKeys[lowerBoundaryIndex + 1];
    return [lowerBoundary, upperBoundary];
}
//# sourceMappingURL=fractional-index.js.map